import { SWRInfiniteResponse } from 'swr/infinite'

import { Paging } from '~/api-definition/definition'

export const offsetPager = (count: number) => {
  return (pageIndex: number) => ({ count: count, offset: pageIndex * count })
}

export const nextPage = <T>(x: SWRInfiniteResponse<T, unknown>) => {
  x.setSize(x.size + 1)
}

export const hasMorePage = <
  K extends keyof T,
  T extends { [k in K]: unknown[] }
>(
  x: SWRInfiniteResponse<T & { paging: Paging }, unknown>
) => {
  if (x.data == null) return false
  if (x.data[0] == null) return true

  const fetched = x.data.reduce((sum, data) => sum + data.paging.count, 0)
  return fetched < x.data[0].paging.all
}
